import { memo, useCallback } from 'react';
import FJVideoRemovePreviewBox from '../view/FJVideoRemovePreviewBox';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJConstant from '../../../../constants/FJConstant';

const FJVideoRemovePreviewBoxContainer = memo(function FJVideoRemovePreviewBoxContainer() {
    useLocalStore();
    const dispatch = useDispatch();

    const editVideoInfo = useSelector(state => state.videoBgRemover.editVideoInfo);
    const tracklets = useSelector(state => state.videoBgRemover.tracklets);
    const currentTime = useSelector(state => state.videoBgRemover.currentTime);
    const hasPointLoading = useSelector(state => state.videoBgRemover.hasPointLoading);
    const isPlaying = useSelector(state => state.videoBgRemover.isPlaying);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    const _addPoint = useCallback(
        point => {
            dispatch(FJActionVideoRemoveBg.addPointAction(point));
        },
        [dispatch],
    );

    const _deletePoint = useCallback(
        index => {
            dispatch(FJActionVideoRemoveBg.deletePointAction(index));
        },
        [dispatch],
    );

    const _deleteErrorPoint = useCallback(
        index => {
            dispatch(FJActionVideoRemoveBg.deleteErrorPointAction(index));
        },
        [dispatch],
    );

    const _retryAddPoint = useCallback(
        index => {
            dispatch(FJActionVideoRemoveBg.retryAddPointAction(index));
        },
        [dispatch],
    );

    const _setCanvas = useCallback(
        canvas => {
            dispatch(FJActionVideoRemoveBg.setCanvasAction(canvas));
        },
        [dispatch],
    );

    const _playVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.playAction());
    }, [dispatch]);

    const _pauseVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    if (headerTabIndex !== FJConstant.CREATIONS) {
        return null;
    }

    return (
        <FJVideoRemovePreviewBox
            editVideoInfo={editVideoInfo}
            addPoint={_addPoint}
            setCanvas={_setCanvas}
            deletePoint={_deletePoint}
            retryAddPoint={_retryAddPoint}
            deleteErrorPoint={_deleteErrorPoint}
            playVideo={_playVideo}
            pauseVideo={_pauseVideo}
            isPlay={isPlaying}
            tracklets={tracklets}
            currentTime={currentTime}
            hasPointLoading={hasPointLoading}
        />
    );
});

export default FJVideoRemovePreviewBoxContainer;
